import TestimonialSlider from 'components/LandingPageCarousels/TestimonialSlider';
import React from 'react';
import Styles from './styles.js';

const AboutUs = ({ bg, blackBackground }) => {
  const data = {
    testimonal: [
      {
        testimonalImg: '/static/images/landingPages/nasri.png',
        testimonalDesc: 'SoulRooms properties are very clean, safe, and vibrant in a f...',
        testimonalDate: 'Nasri Warsame - 5/22/2021',
        testimonalBtn: true,
        testimonalLink: 'https://facebook.com/404951336769102/reviews',
      },
      {
        testimonalImg: '/static/images/landingPages/simar.png',
        testimonalDesc: 'Hi all, This is the first time I have ever come to Canada an...',
        testimonalDate: 'Simar Brar - 9/17/2020',
        testimonalBtn: true,
        testimonalLink: 'https://facebook.com/404951336769102/reviews',
      },
      {
        testimonalImg: '/static/images/landingPages/dipayan.jpg',
        testimonalDesc: 'equipped with less price.',
        testimonalDate: 'Dipayan Chowdhury - 6/4/2020',
        testimonalBtn: false,
      },
      {
        testimonalImg: '/static/images/landingPages/david.png',
        testimonalDesc: 'During a difficult time with the current state of the world, Soul...',
        testimonalDate: 'David Bailis - 4/30/2020',
        testimonalBtn: true,
        testimonalLink: 'https://facebook.com/404951336769102/reviews',
      },
      {
        testimonalImg: '/static/images/landingPages/arjun.png',
        testimonalDesc: 'SoulRooms has definitely been a saving grace for someone just...',
        testimonalDate: 'Arjun Andotra - 4/14/2020',
        testimonalBtn: true,
        testimonalLink: 'https://facebook.com/404951336769102/reviews',
      },
      {
        testimonalImg: '/static/images/landingPages/sharonn.png',
        testimonalDesc: 'Soulrooms is excellent both in the houses they provide and th...',
        testimonalDate: 'Sharon George - 4/14/2020',
        testimonalBtn: true,
        testimonalLink: 'https://facebook.com/404951336769102/reviews',
      },
      {
        testimonalImg: '/static/images/landingPages/clement.png',
        testimonalDesc: 'Warm townhouse fully furnished that suits perfectly people who...',
        testimonalDate: 'Clément Le Fay - 4/13/2020',
        testimonalBtn: true,
        testimonalLink: 'https://facebook.com/404951336769102/reviews',
      },
      {
        testimonalImg: '/static/images/landingPages/phill.png',
        testimonalDesc: 'Soulrooms is an excellent service. From the initial contact...',
        testimonalDate: 'Phill Garrad - 4/12/2020',
        testimonalBtn: true,
        testimonalLink: 'https://facebook.com/404951336769102/reviews',
      },
      {
        testimonalImg: '/static/images/landingPages/rodrigo.png',
        testimonalDesc: "It does not get any better! If you're in Toronto , this is the sp...",
        testimonalDate: 'Rodrigo Forero - 4/12/2020',
        testimonalBtn: true,
        testimonalLink: 'https://facebook.com/404951336769102/reviews',
      },
    ],
  };
  return (
    <>
      {bg == 'true' ? (
        <div className="w-full  p-0  about_us ">
          <div className="container mx-auto">
            <div className=" pt-12 pb-6 mb-4 ">
              <div className=" py-2">
                <h3
                  className="uppercase text-[44px] leading-[55px] font-normal  text-center"
                  style={{ fontFamily: 'Fjalla One', color: '#ffffff' }}>
                  WHAT DO SOULROOMERS SAY ABOUT US?
                </h3>
              </div>
            </div>
            <div className="flex justify-center items-center ">
              <div className=" pb-0">
                <a href="https://web.facebook.com/soulroomstoronto/reviews/" target="_blank" rel="noreferrer">
                  <div className="flex mb-0 justify-center items-center gap-7 ">
                    <div className="flex align-center  text-end p-0 pe-md-4 pe-3 m-0">
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="48"
                        height="48"
                        data-ux="Icon"
                        className="x-el x-el-svg  ">
                        <g>
                          <path
                            d="M22 12c0-5.523-4.477-10-10-10S2
                         6.477 2 12c0 4.991 3.657 9.128 8.438 
                         9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 
                         1.492-3.89 3.777-3.89 1.093 0 2.238.195
                          2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63
                           1.563V12h2.773l-.443 2.89h-2.33v6.988C18.343
                            21.128 22 16.991 22 12z"
                            fill="#1877F2"></path>
                          <path
                            d="M15.893 14.89l.443-2.89h-2.773v-1.875c0-.79.387-1.563 
                        1.63-1.563h1.26v-2.46s-1.144-.196-2.238-.196c-2.284 0-3.777 
                        1.385-3.777 3.89V12h-2.54v2.89h2.54v6.988a10.04
                         10.04 0 003.124 0v-6.987h2.33z"
                            fill="#fff"></path>
                        </g>
                      </svg>
                    </div>
                    <div className=" mt-3 mb-4 mb-lg-0 mt-md-0  p-0 m-0">
                      <div className='flex flex-col'>
                        <p
                          className="  text-[22px] font-normal leading-[33px]  m-0 lh-base p-0"
                          style={{
                            fontFamily: 'Josefin Sans',
                            color: '#ffffff',
                          }}>
                          Soul Rooms <br />
                          100% recommend{' '}
                        </p>

                        <p className="text-base font-normal leading-[20px] m-0 p-0 text-white " style={{ fontFamily: 'Josefin Sans' }}>
                          Based on the opinion of 19 people
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <TestimonialSlider bg iconColor="black" testimonal={data.testimonal} />
        </div>
      ) : (
        <div className={blackBackground ? 'w-full p-0 m-0 oky-2 bg-black' : 'w-full p-0 m-0 bg-none'}>
          <div className="container mx-auto">
            <div className=" pt-12 pb-6 mb-4 ">
              <div className=" py-2">
                <h3
                  className={
                    blackBackground
                      ? 'uppercase text-[44px]  leading-[55px]  font-normal text-white text-center'
                      : 'uppercase fs-48-60 font-normal clrblack text-center'
                  }
                  style={{ fontFamily: 'Fjalla One' }}>
                  WHAT DO SOULROOMERS SAY ABOUT US?
                </h3>
              </div>
            </div>
            <div className="flex justify-center py-2 mt-8 mb-4 ">
              <div className=" pb-0">
                <a href="https://web.facebook.com/soulroomstoronto/reviews/" target="_blank" rel="noreferrer">
                  <div className="flex mb-0 justify-center items-center gap-7  ">
                    <div className="align-self-center  text-end p-0 pe-md-4 pe-3 m-0">
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="48"
                        height="48"
                        data-ux="Icon"
                        className="x-el x-el-svg  ">
                        <g>
                          <path
                            d="M22 12c0-5.523-4.477-10-10-10S2
                         6.477 2 12c0 4.991 3.657 9.128 8.438 
                         9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 
                         1.492-3.89 3.777-3.89 1.093 0 2.238.195
                          2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63
                           1.563V12h2.773l-.443 2.89h-2.33v6.988C18.343
                            21.128 22 16.991 22 12z"
                            fill="#1877F2"></path>
                          <path
                            d="M15.893 14.89l.443-2.89h-2.773v-1.875c0-.79.387-1.563 
                        1.63-1.563h1.26v-2.46s-1.144-.196-2.238-.196c-2.284 0-3.777 
                        1.385-3.777 3.89V12h-2.54v2.89h2.54v6.988a10.04
                         10.04 0 003.124 0v-6.987h2.33z"
                            fill="#fff"></path>
                        </g>
                      </svg>
                    </div>
                    <div className="  mt-md-0  p-0 m-0">
                      <div className='flex flex-col'>
                        <p
                          className=" font-normal fs-22-24 m-0 lh-base p-0"
                          style={{
                            fontFamily: 'Josefin Sans',
                            color: blackBackground ? '#a4a4a4' : '#5e5e5e',
                            fontSize: '18px',
                          }}>
                          Soul Rooms <br />
                          100% recommend{' '}
                        </p>

                        <p
                          className=" fs-16-18 font-normal m-0 p-0 "
                          style={{ fontFamily: 'Josefin Sans', color: blackBackground ? '#a4a4a4' : '#5e5e5e' }}>
                          Based on the opinion of 19 people
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <TestimonialSlider  iconColor="white" testimonal={data.testimonal} />
        </div>
      )}
      <Styles/>
    </>
  );
};

export default AboutUs;
